import { z } from "zod";

const apartmentSchema = z.object({
    globalId: z.string(),
    name: z.string(),
    description: z.string().nullable(),
  });

export default apartmentSchema;